<template>
  <div class="box" >
    <div class="banshi">
      <div class="swiper-prev btn" @click="swiper.slidePrev()"></div>
      <div class="swiper-container" v-if="show">
        <div class="swiper-wrapper">
          <div v-for="item in swiperList" :key="item.id" class="swiper-slide hvr-shrink hvr-glow" :style="`background-image:url(${item.selfCoverPath ? item.selfCoverPath: item.cover})`" @click="toDetail(item.goodsId,item.goodsType)">
          </div>
        </div>
      </div>
      <div class="swiper-next btn" @click="swiper.slideNext()"></div>
    </div>
  </div>
</template>

<script>
import  { getCatalogList, getResourceList } from "@/api/index/index.js";
import Swiper from 'swiper'; // 注意引入的是Swiper
// import 'swiper/css/swiper.min.css' // 注意这里的引入
export default {
  name: "newBooks",
  props:['id'],
  data() {
    return {
      swiper: null,
      swiperList: [
        {id: 1, title: '采集国家二级保护野生植物审批', imgUrl: require("@/assets/images/default-avatar.png")},
        {id: 2, title: '农村危房改造', imgUrl: require("@/assets/images/default-avatar.png")},
        {id: 3, title: '乡村医生执业注册', imgUrl: require("@/assets/images/default-avatar.png")},
        {id: 4, title: '生鲜乳准运证明核发', imgUrl: require("@/assets/images/default-avatar.png")},
        {id: 5, title: '常量命名全部大写，单词间用下划线隔开，力求语义表达完整清楚， 不要嫌名字长', imgUrl: require("@/assets/images/default-avatar.png")},
        {id: 6, title: '使用 2 个空格进行缩进', imgUrl: require("@/assets/images/default-avatar.png"),}
      ],
      imgList:[],
      show: true
    }
  },
  methods:{
    toDetail(id, type) {
      this.$router.push({
        path: "/bookstore/bookstoreDetail",
        query: {
          goodsId: id,
          goodsType: type,
        },
      });
    },
    getList(){
      getResourceList({featuredId: this.id}).then(res=>{
        this.swiperList = res.data
        this.$nextTick(()=>{
          this.swiper = new Swiper(".swiper-container", {
            loop: true, // 无缝
            autoplay: { //自动开始
              delay: 3000, //时间间隔
              disableOnInteraction: false, //*手动操作轮播图后不会暂停*
            },
            paginationClickable: true,
            slidesPerView: 4,
            spaceBetween: 45,//间隔
          })
        })
      })
    }
  },
  activated() {
    this.show = true
    this.swiperList = []
    this.getList()
  },
  deactivated() {
    this.show = false
  },
  mounted() {
    this.getList()
  },
}


</script>

<style scoped lang="scss">
.box{
  background-image: url('../../../assets/images/newbooks-bg.png');
  background-repeat: no-repeat;
  width: 1400px;
  margin: 42px auto 110px;
  background-position-y: 278px;
  height: 350px;
}
.banshi {
  
  width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  .btn{
    width: 60px;
    height: 60px;
    background-image: url('../../../assets/images/swiper-btn.png');
    background-size: 100% 100%;
    cursor: pointer;
  }
  .swiper-next{
    transform: rotate(180deg);
  }
  .swiper-wrapper{
    width: 1066px;
  }
  .swiper-slide {
    position: relative;
    height: 316px;
    width: 230px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-color: #F7F8FA;
    background-size: 100% 100%;
  }
}

</style>